module.exports = __webpack_public_path__ + "static/media/activity-versus.f9407da1.png";